// Max time in millis an enqueued invocation message is allowed to live on the queue.
// NOTE: we choose a number which represents a reasonable portion of a user's session.
// I.e., if a user is SPA navigating a web / desktop app, we expect them to stick around
// for more than a typical web page. The longer they stay, the more the probability of objects
// starting to hang around in memory. But also: we don't want to clean up too soon in case we
// have a flakey receiver / want to peform a full event replay / rehydration. Hence the number
// chosen below. For future readers consider AI networking streams & events (long-running).
export var MESSAGE_LIFETIME_IN_MILLIS = 90000;

// Time in millis we schedule each tick when attempting to clean up.
export var MESSAGE_TICK_TIME_IN_MILLIS = 100;

// Maximum number of messages allowed per receiver to prevent memory exhaustion.
export var MAX_MESSAGES_PER_RECEIVER = 1000;

// Maximum total messages across all receivers.
export var MAX_TOTAL_MESSAGES = 10000;